/* ZIGZAG — animaciones e interacciones (JS vanilla, sin librerías)
   Cada init() empieza comprobando que su elemento existe, así el mismo archivo sirve en todas las páginas. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };

  // Mismo formato de precio que usa la tienda en Liquid (shop.money_format)
  function money(cents) {
    var fmt = window.zzMoney || '€{{amount_with_comma_separator}}';
    function group(n, precision, thou, dec) {
      var s = (n / 100).toFixed(precision).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return s[0] + (s[1] ? dec + s[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(cents, 2, ' ', '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  }
  function readJSON(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }
  function tierPct(tiers, qty) {
    var pct = 0;
    (tiers || []).forEach(function (t) { if (qty >= t.qty && t.pct > pct) pct = t.pct; });
    return pct;
  }

  /* ---------- Revelado al hacer scroll (un solo observador compartido) ---------- */
  function splitWords(root) {
    $$('[data-zz-split]', root).forEach(function (el) {
      if (el.dataset.zzDone) return;
      el.dataset.zzDone = '1';
      var i = 0, lastS = null;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            var txt = n.textContent;
            // La puntuación que abre un texto (p. ej. la coma tras una cursiva) se pega a la palabra anterior
            var lead = txt.match(/^([,.;:!?…»”)]+)/);
            if (lead && lastS) { lastS.textContent += lead[1]; txt = txt.slice(lead[1].length); }
            txt.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span');
              w.className = 'zz-w';
              var s = document.createElement('span');
              s.style.setProperty('--i', i++);
              s.textContent = part;
              lastS = s;
              w.appendChild(s);
              frag.appendChild(w);
            });
            node.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') {
            walk(n);
          }
        });
      })(el);
    });
  }

  function initReveal() {
    splitWords(document);
    var targets = $$('.zz-reveal, .zz-imgreveal, [data-zz-split], .zz-row__line, .zz-ic--si, .zz-paso__frame');
    if (!targets.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('zz-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('zz-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Barra de progreso + parallax + isla de compra (un único listener de scroll) ---------- */
  var scrollHooks = [];
  function initScroll() {
    var bar = document.createElement('div');
    bar.className = 'zz-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var pars = $$('[data-zz-parallax]');
    var ticking = false;

    function frame() {
      ticking = false;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--zz-p', h > 0 ? clamp(window.scrollY / h, 0, 1).toFixed(4) : 0);
      if (!reduce) {
        pars.forEach(function (el) {
          var r = el.parentElement.getBoundingClientRect();
          if (r.bottom < -100 || r.top > window.innerHeight + 100) return;
          var k = parseFloat(el.dataset.zzParallax) || 0.12;
          el.style.setProperty('--zz-py', ((r.top + r.height / 2 - window.innerHeight / 2) * -k).toFixed(1) + 'px');
        });
      }
      scrollHooks.forEach(function (fn) { fn(); });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  /* ---------- Hero: hojas que reaccionan al ratón ---------- */
  function initHero() {
    var hero = $('.zz-hero');
    if (!hero || reduce || !fine) return;
    var leaves = $('.zz-hero__leaves', hero);
    if (!leaves) return;
    var raf = 0;
    hero.addEventListener('pointermove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var r = hero.getBoundingClientRect();
        var mx = ((e.clientX - r.left) / r.width - 0.5).toFixed(3);
        var my = ((e.clientY - r.top) / r.height - 0.5).toFixed(3);
        $$('.zz-leaf', leaves).forEach(function (l) {
          l.style.setProperty('--mx', mx);
          l.style.setProperty('--my', my);
        });
      });
    });
  }

  /* ---------- Tarjetas con inclinación 3D ---------- */
  function initTilt() {
    if (reduce || !fine) return;
    $$('.zz-card').forEach(function (card) {
      var inner = $('.zz-card__inner', card);
      if (!inner) return;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.classList.add('is-tilting');
        card.style.setProperty('--rx', (-y * 9).toFixed(2) + 'deg');
        card.style.setProperty('--ry', (x * 11).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Pasos: contador sticky que cambia con el scroll ---------- */
  function initPasos() {
    var root = $('.zz-pasos');
    if (!root) return;
    var pasos = $$('.zz-paso', root);
    var nums = $$('.zz-pasos__now span', root);
    if (!pasos.length) return;
    var current = -1;
    function set(i) {
      if (i === current) return;
      current = i;
      pasos.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
      nums.forEach(function (n, k) {
        n.classList.toggle('is-off-up', k < i);
        n.classList.toggle('is-off-down', k > i);
      });
      root.style.setProperty('--zz-pp', ((i + 1) / pasos.length).toFixed(3));
    }
    set(0);
    if (!('IntersectionObserver' in window)) { pasos.forEach(function (p) { p.classList.add('is-active'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) set(pasos.indexOf(e.target));
      });
    }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
    pasos.forEach(function (p) { io.observe(p); });
  }

  /* ---------- Preguntas frecuentes ---------- */
  function initFaq() {
    $$('.zz-qa').forEach(function (qa) {
      var q = $('.zz-qa__q', qa);
      if (!q || qa.dataset.zzBound) return;
      qa.dataset.zzBound = '1';
      q.setAttribute('aria-expanded', qa.classList.contains('is-open') ? 'true' : 'false');
      q.addEventListener('click', function () {
        var open = !qa.classList.contains('is-open');
        var group = qa.parentElement;
        if (group && group.hasAttribute('data-zz-single')) {
          $$('.zz-qa.is-open', group).forEach(function (o) {
            if (o !== qa) { o.classList.remove('is-open'); $('.zz-qa__q', o).setAttribute('aria-expanded', 'false'); }
          });
        }
        qa.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Añadir al carrito (packs con varios colores) ---------- */
  function jsonHeaders() { return { 'Content-Type': 'application/json', Accept: 'application/json' }; }

  /* Regalos automáticos: se añaden y se quitan solos según cuántos peces haya en el carrito.
     Los regalos llevan la propiedad oculta _regalo para no tocar lo que el cliente compre aparte. */
  function syncGifts() {
    var cfg = readJSON(document.getElementById('zz-cart-config'), null);
    if (!cfg || !cfg.gifts || !cfg.gifts.length) return Promise.resolve(false);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fish = 0;
        cart.items.forEach(function (i) { if (i.product_id === cfg.pez) fish += i.quantity; });
        var updates = {}, adds = [];
        cfg.gifts.forEach(function (g) {
          var want = fish >= g.min && g.available;
          var lines = cart.items.filter(function (i) { return i.product_id === g.productId && i.properties && i.properties._regalo; });
          var cur = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
          if (want && cur === 0) adds.push({ id: g.id, quantity: 1, properties: { _regalo: '1' } });
          else if (want && cur > 1) lines.forEach(function (l, k) { updates[l.key] = k === 0 ? 1 : 0; });
          else if (!want && cur > 0) lines.forEach(function (l) { updates[l.key] = 0; });
        });
        var p = Promise.resolve(false);
        if (Object.keys(updates).length) {
          p = p.then(function () {
            return fetch('/cart/update.js', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ updates: updates }) }).then(function () { return true; });
          });
        }
        if (adds.length) {
          p = p.then(function () {
            return fetch('/cart/add.js', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ items: adds }) }).then(function () { return true; });
          });
        }
        return p;
      });
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return Promise.resolve(); }
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ sections: sections }); });
  }

  var syncing = false, syncAgain = false;
  function runSync() {
    if (syncing) { syncAgain = true; return; }
    syncing = true;
    syncGifts()
      .then(function (changed) { return changed ? refreshDrawer() : null; })
      .catch(function () {})
      .then(function () { syncing = false; if (syncAgain) { syncAgain = false; runSync(); } });
  }
  function initCartSync() {
    // Cambios hechos dentro del carrito (más/menos peces, quitar…): Dawn avisa con cartUpdate
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !window.__zzCartSync) {
      window.__zzCartSync = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { runSync(); });
    }
  }

  /* ---------- Cantidades del carrito lateral ----------
     Cola ordenada: los clics se acumulan, se aplican de uno en uno sobre el estado real del carrito
     y el repintado nunca pisa un clic que aún está pendiente. */
  var qPend = {}, qTimer = null, qBusy = false;

  function qQueue(variantId, op) {
    var p = qPend[variantId] || (qPend[variantId] = { delta: 0, remove: false, set: null });
    if (op.remove) p.remove = true;
    else if (op.set != null) { p.set = op.set; p.delta = 0; }
    else p.delta += op.delta;
    clearTimeout(qTimer);
    qTimer = setTimeout(qFlush, 180);
  }

  function qFishLine(variantId) { return $('.zz-line[data-variant="' + variantId + '"]:not(.zz-line--gift)'); }

  function qPaintQty(line, value) {
    var input = $('input.quantity__input', line);
    if (!input) return;
    input.value = value;
    var minus = $('.quantity__button[name="minus"]', line);
    if (minus) minus.classList.toggle('disabled', value <= 1);
  }

  // Tras repintar, vuelve a mostrar lo que el cliente ya ha pulsado y aún no se ha aplicado
  function qApplyPending() {
    Object.keys(qPend).forEach(function (vid) {
      var p = qPend[vid], line = qFishLine(vid);
      if (!line) return;
      var input = $('input.quantity__input', line);
      var base = p.set != null ? p.set : (parseInt(input && input.value, 10) || 1);
      qPaintQty(line, Math.max(1, base + p.delta));
      if (p.remove) line.classList.add('is-removing');
    });
  }

  function qFlush() {
    if (qBusy) return;
    var work = qPend;
    qPend = {};
    var ids = Object.keys(work);
    if (!ids.length) return;
    qBusy = true;
    var errorMsg = null;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        ids.forEach(function (vid) {
          var lines = cart.items.filter(function (i) { return String(i.variant_id) === vid && !(i.properties && i.properties._regalo); });
          if (!lines.length) return;
          var cur = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
          var op = work[vid], target;
          if (op.remove) target = 0;
          else target = Math.max(1, (op.set != null ? op.set : cur) + op.delta);
          lines.forEach(function (l, k) { updates[l.key] = k === 0 ? target : 0; });
        });
        if (!Object.keys(updates).length) return null;
        return fetch('/cart/update.js', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ updates: updates }) })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (j && j.status) errorMsg = j.description || j.message || 'No se pudo cambiar la cantidad'; });
      })
      .then(function () { return syncGifts(); })
      .then(function () { return refreshDrawer(); })
      .then(function () {
        if (errorMsg) {
          var line = qFishLine(ids[0]);
          var t = line && $('.cart-item__error-text', line);
          if (t) t.textContent = errorMsg;
        }
      })
      .catch(function () {})
      .then(function () {
        qBusy = false;
        qApplyPending();
        if (Object.keys(qPend).length) qFlush();
      });
  }

  function initCartControls() {
    if (window.__zzQty) return;
    window.__zzQty = true;
    document.addEventListener('click', function (e) {
      var tgt = e.target;
      if (!tgt || !tgt.closest) return;
      var btn = tgt.closest('.zz-line .zz-q button[name]');
      if (btn) {
        e.preventDefault(); e.stopImmediatePropagation();
        var line = btn.closest('.zz-line'), input = $('input.quantity__input', line);
        var d = btn.name === 'plus' ? 1 : -1;
        var cur = parseInt(input.value, 10) || 1;
        if (d < 0 && cur <= 1) return;
        qPaintQty(line, cur + d);
        qQueue(line.dataset.variant, { delta: d });
        return;
      }
      var rm = tgt.closest('.zz-line .cart-remove-button');
      if (rm) {
        e.preventDefault(); e.stopImmediatePropagation();
        var l2 = rm.closest('.zz-line');
        l2.classList.add('is-removing');
        qQueue(l2.dataset.variant, { remove: true });
      }
    }, true);
    document.addEventListener('change', function (e) {
      var tgt = e.target;
      if (!tgt || !tgt.closest) return;
      var inp = tgt.closest('.zz-line input.quantity__input[type="number"]');
      if (!inp) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var v = parseInt(inp.value, 10);
      if (!v || v < 1) v = 1;
      var line = inp.closest('.zz-line');
      qPaintQty(line, v);
      qQueue(line.dataset.variant, { set: v });
    }, true);
  }

  function addToCart(items, onDone) {
    var cart = document.querySelector('cart-drawer');
    return fetch('/cart/add.js', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { if (onDone) onDone(res.description || res.message || 'Error'); return; }
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        return syncGifts()
          .then(function () { return refreshDrawer(); })
          .then(function () { if (onDone) onDone(null); });
      })
      .catch(function (e) { if (onDone) onDone((e && e.message) || 'Error de red'); });
  }

  /* ---------- Ficha de producto ---------- */
  function initProducto() {
    var root = $('[data-zz-pdp]');
    if (!root || root.dataset.zzBound) return;
    root.dataset.zzBound = '1';
    var variants = readJSON($('[data-zz-variants]', root), []);
    var tiers = readJSON($('[data-zz-tiers]', root), []);
    var form = $('form[data-type="add-to-cart-form"]', root);
    var productForm = $('product-form', root);
    var idInput = form && $('input[name="id"]', form);
    var priceEl = $('[data-zz-price]', root);
    var btn = form && $('[type="submit"]', form);
    var btnText = btn && $('span', btn);
    var stage = $$('.zz-pdp__slide', root);
    var thumbs = $$('.zz-pdp__thumb', root);
    var unitsEl = $('[data-zz-units]', root);
    var saveEl = $('[data-zz-save]', root);
    var stockEl = $('[data-zz-stock]', root);
    var optWrap = $('[data-zz-optwrap]', root);
    var packEls = $$('.zz-pack', root);
    var gifts = $$('.zz-gift', root);
    var errorEl = $('.product-form__error-message', root);
    var errorWrap = $('.product-form__error-message-wrapper', root);
    var unitName = root.dataset.unitSingular || 'pez';
    var strings = {
      add: root.dataset.txtAdd || 'Añadir al carrito',
      sold: root.dataset.txtSold || 'Agotado',
      unavailable: root.dataset.txtUnavailable || 'No disponible'
    };
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });
    var state = { qty: 1, units: [] };

    function show(i) {
      stage.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var t = thumbs[i];
      if (t && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
        t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var stageEl = $('.zz-pdp__stage', root);
    if (stageEl && stage.length > 1) {
      var sx = null;
      stageEl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stageEl.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) < 40) return;
        var cur = stage.findIndex(function (s) { return s.classList.contains('is-active'); });
        show(clamp(cur + (dx < 0 ? 1 : -1), 0, stage.length - 1));
      });
    }

    function mainVariant() {
      var sel = $$('.zz-opt', root).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    }
    function swatchOf(v) { return (v.options[0] || '').toLowerCase(); }

    function renderUnits() {
      if (!unitsEl) return;
      unitsEl.innerHTML = '';
      state.units.forEach(function (vid, n) {
        var row = document.createElement('div');
        row.className = 'zz-unit';
        var lab = document.createElement('span');
        lab.className = 'zz-unit__n';
        lab.textContent = unitName.charAt(0).toUpperCase() + unitName.slice(1) + ' ' + (n + 1);
        row.appendChild(lab);
        var vals = document.createElement('div');
        vals.className = 'zz-opt__vals';
        variants.forEach(function (v) {
          var l = document.createElement('label');
          l.setAttribute('data-swatch', swatchOf(v));
          var i = document.createElement('input');
          i.type = 'radio'; i.name = 'zz-unit-' + n; i.value = v.id;
          i.checked = v.id === vid;
          if (!v.available) i.disabled = true;
          var p = document.createElement('span');
          p.className = 'zz-pill';
          var dot = document.createElement('i'); dot.className = 'zz-dot';
          p.appendChild(dot);
          p.appendChild(document.createTextNode(v.options[0] || v.title));
          l.appendChild(i); l.appendChild(p);
          i.addEventListener('change', function () {
            state.units[n] = v.id;
            if (n === 0) syncMainPicker(v);
            update(true);
          });
          vals.appendChild(l);
        });
        row.appendChild(vals);
        unitsEl.appendChild(row);
      });
    }

    function syncMainPicker(v) {
      $$('.zz-opt', root).forEach(function (g, gi) {
        $$('input', g).forEach(function (i) { i.checked = (i.value === v.options[gi]); });
      });
    }

    function setQty(q, silent) {
      q = Math.max(1, q | 0);
      var first = state.units[0] || (mainVariant() || variants[0]).id;
      state.qty = q;
      state.units = state.units.slice(0, q);
      while (state.units.length < q) state.units.push(state.units.length ? state.units[state.units.length - 1] : first);
      state.units[0] = first;
      packEls.forEach(function (p) {
        var on = parseInt(p.dataset.qty, 10) === q;
        var inp = $('input', p); if (inp) inp.checked = on;
        p.classList.toggle('is-on', on);
      });
      if (q > 1 && unitsEl) { renderUnits(); unitsEl.hidden = false; if (optWrap) optWrap.hidden = true; }
      else { if (unitsEl) unitsEl.hidden = true; if (optWrap) optWrap.hidden = false; }
      if (!silent) update(false);
    }

    // Valor (a precio normal) de los regalos que se llevan con un pack de q peces
    function giftsValue(q) {
      var s = 0;
      gifts.forEach(function (g) {
        if (q >= parseInt(g.dataset.min, 10) && g.dataset.available !== 'false') s += parseInt(g.dataset.price, 10) || 0;
      });
      return s;
    }

    function totals() {
      var orig = 0;
      state.units.forEach(function (id) { orig += (byId[id] ? byId[id].price : 0); });
      var pct = tierPct(tiers, state.qty);
      var total = orig - Math.floor(orig * pct / 100);
      var gv = giftsValue(state.qty);
      // orig = solo los peces (base del descuento); show = precio tachado (peces + regalos); save = lo que ahorra en total
      // pctAll = ahorro total (peces + regalos) sobre el precio tachado
      return { orig: orig, total: total, pct: pct, gv: gv, show: orig + gv, save: orig + gv - total, pctAll: (orig + gv) ? Math.round((orig + gv - total) / (orig + gv) * 100) : 0 };
    }

    // Regalos desbloqueados según el pack elegido
    function activeGifts() {
      return gifts.filter(function (g) { return state.qty >= parseInt(g.dataset.min, 10) && g.dataset.available !== 'false'; });
    }
    function paintGifts() {
      gifts.forEach(function (g) {
        var on = state.qty >= parseInt(g.dataset.min, 10) && g.dataset.available !== 'false';
        g.classList.toggle('is-on', on);
        g.classList.toggle('is-locked', !on);
        var s = $('.zz-gift__state', g);
        if (s) s.textContent = on ? s.dataset.on : s.dataset.off;
      });
    }

    function update(fromUser) {
      var first = byId[state.units[0]] || mainVariant() || variants[0];
      if (!first) return;
      if (state.qty === 1) {
        var mv = mainVariant() || first;
        state.units = [mv.id];
        first = mv;
      }
      $$('.zz-opt', root).forEach(function (g) {
        var name = $('[data-zz-optval]', g), c = $('input:checked', g);
        if (name && c) name.textContent = c.value;
      });
      if (idInput) idInput.value = first.id;
      var unitsOk = state.units.every(function (id) { return byId[id] && byId[id].available; });
      var t = totals();

      if (priceEl) {
        priceEl.innerHTML = '<span>' + money(first.price) + '</span>' +
          (first.compare_at_price && first.compare_at_price > first.price ? '<s>' + money(first.compare_at_price) + '</s><span class="zz-off">-' + Math.round((1 - first.price / first.compare_at_price) * 100) + '%</span>' : '');
      }
      packEls.forEach(function (p) {
        var q = parseInt(p.dataset.qty, 10);
        var pc = tierPct(tiers, q);
        var sum = (q === state.qty) ? t.orig : first.price * q;
        var tot = sum - Math.floor(sum * pc / 100);
        var tEl = $('[data-pack-total]', p), oEl = $('[data-pack-orig]', p);
        if (tEl) tEl.textContent = money(tot);
        if (oEl) oEl.textContent = money(sum + giftsValue(q));
      });
      if (saveEl) {
        if (t.save > 0) {
          var ng = activeGifts().length;
          saveEl.hidden = false;
          saveEl.textContent = 'Ahorras ' + money(t.save) + ' (' + (t.pct ? '−' + t.pct + '% en los peces' : '') + (t.pct && ng ? ' + ' : '') + (ng ? ng + (ng === 1 ? ' regalo' : ' regalos') + ' gratis' : '') + ') · aplicado automáticamente en el carrito';
        }
        else saveEl.hidden = true;
      }
      if (stockEl) {
        var um = parseInt(stockEl.dataset.umbral, 10) || 0;
        if (um > 0 && first.stock != null && first.stock > 0 && first.stock <= um) {
          stockEl.hidden = false; stockEl.textContent = 'Quedan solo ' + first.stock + ' unidades de este color';
        } else stockEl.hidden = true;
      }
      if (btn) {
        if (!unitsOk) { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = strings.sold; }
        else { btn.removeAttribute('disabled'); if (btnText) btnText.textContent = strings.add + ' · ' + money(t.total); }
      }
      if (fromUser && first.featured_media_pos != null && first.featured_media_pos >= 0 && first.featured_media_pos < stage.length) show(first.featured_media_pos);
      if (window.location.pathname.indexOf('/products/') === 0) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', first.id);
        window.history.replaceState({}, '', url.toString());
      }
      paintGifts();
      window.__zzLastPack = { qty: state.qty, total: t.total, orig: t.show, pct: t.pctAll, save: t.save, available: unitsOk, unit: unitName, gifts: activeGifts().length };
      document.dispatchEvent(new CustomEvent('zz:pack', { detail: window.__zzLastPack }));
    }

    $$('.zz-opt input', root).forEach(function (i) { i.addEventListener('change', function () { state.units = []; update(true); }); });
    packEls.forEach(function (p) {
      var inp = $('input', p);
      if (inp) inp.addEventListener('change', function () { setQty(parseInt(p.dataset.qty, 10)); });
    });

    // Enviar: siempre por nuestro propio envío (permite packs con colores distintos)
    if (productForm && form) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!btn || btn.getAttribute('aria-disabled') === 'true' || btn.hasAttribute('disabled')) return;
        var groups = {};
        state.units.forEach(function (id) { groups[id] = (groups[id] || 0) + 1; });
        var items = Object.keys(groups).map(function (id) { return { id: parseInt(id, 10), quantity: groups[id] }; });
        // Los regalos los añade el carrito solo (syncGifts), según los peces que haya en total
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        var sp = $('.loading__spinner', btn); if (sp) sp.classList.remove('hidden');
        if (errorWrap) errorWrap.hidden = true;
        addToCart(items, function (err) {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (sp) sp.classList.add('hidden');
          if (err && errorWrap && errorEl) { errorEl.textContent = err; errorWrap.hidden = false; }
        });
      }, true);
    }

    // Enlace directo a un pack: ?pack=3
    var wanted = parseInt(new URLSearchParams(window.location.search).get('pack'), 10);
    var start = (mainVariant() || variants[0]);
    state.units = start ? [start.id] : [];
    if (wanted && packEls.some(function (p) { return parseInt(p.dataset.qty, 10) === wanted; })) setQty(wanted, true);
    else setQty(1, true);
    update(false);
    window.zzProducto = { setQty: function (q) { setQty(q); }, submit: function () { if (form && form.requestSubmit) form.requestSubmit(btn); else if (btn) btn.click(); } };
  }

  /* ---------- Isla de compra permanente ---------- */
  function initIsla() {
    var el = $('.zz-isla');
    if (!el || el.dataset.zzBound) return;
    el.dataset.zzBound = '1';
    // Si la página ya tiene la ficha de compra (portada o ficha), la isla copia su pack
    var mode = window.zzProducto ? 'mirror' : el.dataset.mode;
    if (mode === 'mirror') el.classList.add('is-mirror');
    var btn = $('.zz-isla__btn', el);
    var btnLabel = $('.zz-isla__btn span', el);
    var sumEl = $('[data-zz-isla-sum]', el);
    var priceEl = $('[data-zz-isla-price]', el);
    var origEl = $('[data-zz-isla-orig]', el);
    var addTxt = el.dataset.txtAdd || 'Añadir al carrito';
    var doneTxt = el.dataset.txtDone || 'Añadido ✓';
    var soldTxt = el.dataset.txtSold || 'Agotado';

    // Cuándo se muestra: al salir del apartado de ofertas (o tras un rato de scroll si no hay)
    var trigger = $('[data-zz-offers]');
    function passed() {
      if (trigger) { var r = trigger.getBoundingClientRect(); return r.bottom < 40; }
      return window.scrollY > 700;
    }
    scrollHooks.push(function () { el.classList.toggle('is-on', passed()); });
    el.classList.toggle('is-on', passed());

    if (mode === 'mirror') {
      var applyPack = function (d) {
        if (!d) return;
        if (sumEl) sumEl.textContent = d.qty + ' ' + (d.qty === 1 ? d.unit : (el.dataset.unitPlural || d.unit + 's')) + (d.pct ? ' · −' + d.pct + '%' : '') + (d.gifts ? ' · +' + d.gifts + (d.gifts === 1 ? ' regalo' : ' regalos') : '');
        if (priceEl) priceEl.textContent = money(d.total);
        if (origEl) { origEl.textContent = d.save > 0 ? money(d.orig) : ''; }
        if (btn) { btn.disabled = !d.available; if (btnLabel) btnLabel.textContent = d.available ? addTxt : soldTxt; }
      };
      document.addEventListener('zz:pack', function (e) { applyPack(e.detail); });
      applyPack(window.__zzLastPack);
      if (btn) btn.addEventListener('click', function () { if (window.zzProducto) window.zzProducto.submit(); });
      return;
    }

    // Modo propio (portada): color + cantidad
    var variants = readJSON($('[data-zz-isla-variants]', el), []);
    var tiers = readJSON($('[data-zz-isla-tiers]', el), []);
    var st = { vid: (variants.find(function (v) { return v.available; }) || variants[0] || {}).id, qty: 1 };
    var dots = $$('.zz-dots button', el);
    var segs = $$('.zz-seg button', el);
    var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });

    function draw() {
      var v = byId[st.vid]; if (!v) return;
      var orig = v.price * st.qty, pct = tierPct(tiers, st.qty), total = orig - Math.floor(orig * pct / 100);
      dots.forEach(function (d) { d.classList.toggle('is-on', parseInt(d.dataset.vid, 10) === st.vid); d.setAttribute('aria-pressed', parseInt(d.dataset.vid, 10) === st.vid ? 'true' : 'false'); });
      segs.forEach(function (s) { s.classList.toggle('is-on', parseInt(s.dataset.qty, 10) === st.qty); s.setAttribute('aria-pressed', parseInt(s.dataset.qty, 10) === st.qty ? 'true' : 'false'); });
      if (priceEl) priceEl.textContent = money(total);
      if (origEl) origEl.textContent = pct ? money(orig) : '';
      if (sumEl) sumEl.textContent = pct ? '−' + pct + '% aplicado' : '';
      if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? addTxt : soldTxt; }
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { st.vid = parseInt(d.dataset.vid, 10); draw(); }); });
    segs.forEach(function (s) { s.addEventListener('click', function () { st.qty = parseInt(s.dataset.qty, 10); draw(); }); });
    if (btn) btn.addEventListener('click', function () {
      if (btn.disabled || btn.dataset.busy) return;
      btn.dataset.busy = '1';
      addToCart([{ id: st.vid, quantity: st.qty }], function (err) {
        delete btn.dataset.busy;
        if (btnLabel) {
          btnLabel.textContent = err ? err : doneTxt;
          setTimeout(function () { draw(); }, 2200);
        }
      });
    });
    draw();
  }

  /* ---------- Vídeos ---------- */
  function initVideos() {
    var cards = $$('.zz-vcard');
    if (!cards.length) return;
    var vids = cards.map(function (c) { return $('video', c); }).filter(Boolean);
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.55) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: [0, 0.55, 1] });
      vids.forEach(function (v) { io.observe(v); });
    }
    cards.forEach(function (c) {
      var v = $('video', c), snd = $('.zz-vcard__snd', c);
      if (!v) return;
      if (snd) snd.addEventListener('click', function (e) {
        e.stopPropagation();
        vids.forEach(function (o) { if (o !== v) { o.muted = true; var b = $('.zz-vcard__snd', o.closest('.zz-vcard')); if (b) b.classList.remove('is-on'); } });
        v.muted = !v.muted;
        snd.classList.toggle('is-on', !v.muted);
        snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        if (!v.muted && v.paused) v.play();
      });
      c.addEventListener('click', function (e) {
        if (e.target.closest('.zz-vcard__snd')) return;
        if (v.paused) v.play(); else v.pause();
      });
    });
  }

  /* ---------- Carrusel horizontal (flechas, teclado, arrastre con ratón, deslizar en móvil) ---------- */
  function initCarousel() {
    $$('[data-zz-carousel]').forEach(function (st) {
      if (st.dataset.zzBound) return;
      st.dataset.zzBound = '1';
      var track = $('.zz-com__track', st), prev = $('[data-zz-prev]', st), next = $('[data-zz-next]', st);
      if (!track) return;
      function cardW() {
        var c = track.firstElementChild;
        return c ? c.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
      }
      function page() { return cardW() * Math.max(1, Math.floor(track.clientWidth / cardW()) - 1 || 1); }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 12;
        if (next) next.disabled = track.scrollLeft >= max - 12;
        st.classList.toggle('is-static', max <= 16);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: cardW(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -cardW(), behavior: 'smooth' }); }
      });
      // Arrastrar con el ratón
      var down = false, moved = false, sx = 0, sl = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button')) return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-drag'); }
        if (moved) track.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-drag');
        setTimeout(function () { moved = false; }, 0);
      });
      track.addEventListener('click', function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); } }, true);
      update();
      setTimeout(update, 600);
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initBA() {
    $$('.zz-ba').forEach(function (ba) {
      if (ba.dataset.zzBound) return;
      ba.dataset.zzBound = '1';
      var input = $('input[type=range]', ba);
      if (!input) return;
      function set(v) { ba.style.setProperty('--p', v + '%'); input.value = v; }
      input.addEventListener('input', function () { ba.classList.add('is-used'); set(input.value); });
      set(50);
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          var t0 = null, from = 94, to = 50, dur = 1500;
          (function step(t) {
            if (ba.classList.contains('is-used')) return;
            if (t0 === null) t0 = t;
            var k = clamp((t - t0) / dur, 0, 1);
            var ease = 1 - Math.pow(1 - k, 4);
            set(Math.round((from + (to - from) * ease) * 10) / 10);
            if (k < 1) requestAnimationFrame(step);
          })(performance.now());
        });
      }, { threshold: 0.5 });
      io.observe(ba);
    });
  }

  /* ---------- Cuenta atrás de oferta (solo si se pone una fecha real) ---------- */
  function initCountdown() {
    $$('[data-zz-countdown]').forEach(function (el) {
      if (el.dataset.zzCdBound) return;
      el.dataset.zzCdBound = '1';
      var end = Date.parse(el.dataset.zzCountdown);
      var txt = el.parentElement && $('[data-zz-cd-text]', el.parentElement);
      var cells = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
      var dayUnit = $('[data-cd-unit="d"]', el);
      var hideDays = el.dataset.zzCdHideDays === 'true';
      function expire() {
        el.hidden = true;
        if (txt && txt.dataset.expired) txt.textContent = txt.dataset.expired;
      }
      if (!end) { expire(); return; }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (left === 0) { expire(); return; }
        var s = Math.floor(left / 1000);
        var days = Math.floor(s / 86400);
        if (dayUnit) {
          var showDays = !hideDays && days > 0;
          dayUnit.style.display = showDays ? '' : 'none';
          if (dayUnit.nextElementSibling) dayUnit.nextElementSibling.style.display = showDays ? '' : 'none';
        }
        if (cells.d) cells.d.textContent = pad(days);
        if (cells.h) cells.h.textContent = pad(Math.floor(s % 86400 / 3600));
        if (cells.m) cells.m.textContent = pad(Math.floor(s % 3600 / 60));
        if (cells.s) cells.s.textContent = pad(s % 60);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- Arranque ---------- */
  function init() {
    initReveal();
    initScroll();
    initHero();
    initTilt();
    initPasos();
    initFaq();
    initProducto();
    initIsla();
    initVideos();
    initCarousel();
    initBA();
    initCountdown();
    initCartSync();
    initCartControls();
    window.__zzReady = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // El editor de Shopify recarga secciones sueltas: vuelve a preparar lo nuevo
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initTilt(); initPasos(); initFaq(); initProducto(); initIsla(); initVideos(); initCarousel(); initBA(); initCountdown();
    $$('.zz-reveal, .zz-imgreveal, [data-zz-split]').forEach(function (t) { t.classList.add('zz-in'); });
  });
})();
